import { render } from "./MatrizBadge.vue?vue&type=template&id=2f5fde36"
import script from "./MatrizBadge.vue?vue&type=script&lang=js"
export * from "./MatrizBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__